// Video Animation pricing model
// Two product types: AI Motion (fast/marketing) & Cinematic Film (premium/produced)
// One optional add-on: Social Media Pack

export const VIDEO_ANIMATION_TYPES = {
  ai: {
    key: "ai",
    label: "AI Motion",
    tagline: "Fast. Marketing-grade. Rapid go-to-market.",
    subtitle:
      "Optimized for speed and marketing performance. Uses existing render assets to create cinematic motion content ideal for ads, social, and rapid go-to-market.",
    pricing: {
      30: { price: 4500, shots: 10, label: "30 Seconds" },
      60: { price: 8500, shots: 20, label: "60 Seconds" },
      90: { price: 12000, shots: 30, label: "90 Seconds" },
    },
    displayName: (duration) => `AI Motion Video – ${duration} Second Film`,
    includes: [
      "AI-driven motion from existing renders",
      "Editing, music & sound design",
      "1 revision",
    ],
  },
  cinematic: {
    key: "cinematic",
    label: "Cinematic Film",
    tagline: "Fully produced. Flagship-grade. Built to last.",
    subtitle:
      "High-end, fully produced animation with advanced camera work, lighting, and detailed scene production. Designed for flagship marketing and long-term brand assets.",
    pricing: {
      30: { price: 8500, shots: 10, label: "30 Seconds" },
      60: { price: 14500, shots: 20, label: "60 Seconds" },
      90: { price: 18000, shots: 30, label: "90 Seconds" },
    },
    displayName: (duration) => `Cinematic Film – ${duration} Second Film`,
    includes: [
      "Storyboarding",
      "Cinematic animation",
      "Editing, music & sound design",
      "1 revision",
    ],
  },
};

export const SOCIAL_MEDIA_PACK = {
  key: "social_media_pack",
  price: 2000,
  label: "Social Media Pack",
  subtitle:
    "Includes short-form cutdowns (10–15 second clips) and vertical versions optimized for paid ads and social distribution.",
};

export const DURATION_OPTIONS = [30, 60, 90];

export function getAnimationTier(type, duration) {
  const t = VIDEO_ANIMATION_TYPES[type];
  if (!t) return null;
  return t.pricing[duration] || null;
}

export function getAnimationPrice(type, duration) {
  const tier = getAnimationTier(type, duration);
  return tier ? tier.price : 0;
}

export function getAnimationShots(type, duration) {
  const tier = getAnimationTier(type, duration);
  return tier ? tier.shots : 0;
}

export function getAnimationDisplayName(type, duration) {
  const t = VIDEO_ANIMATION_TYPES[type];
  return t ? t.displayName(duration) : `Animation ${duration}sec`;
}

export function getShotCountText(type, duration) {
  const tier = getAnimationTier(type, duration);
  if (!tier) return "";
  if (type === "cinematic") {
    return `Estimated shot count: ${tier.shots} shots (3 seconds per shot)`;
  }
  return `Estimated shot count: ${tier.shots} shots`;
}

export function getAnimationIncludes(type) {
  const t = VIDEO_ANIMATION_TYPES[type];
  return t ? t.includes : [];
}
